module.exports = __webpack_public_path__ + "static/media/locationWMarker.27e07731.svg";